import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { VIDEO } from "@/lib/assets";

export default function VideoBand() {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const y = useTransform(scrollYProgress, [0, 1], ["-12%", "12%"]);

  return (
    <section ref={ref} data-testid="video-band" className="relative h-[280px] sm:h-[380px] overflow-hidden">
      <motion.video
        style={{ y }}
        className="absolute left-0 top-[-10%] w-full h-[120%] object-cover"
        autoPlay
        muted
        loop
        playsInline
        preload="metadata"
      >
        <source src={VIDEO.band} type="video/mp4" />
      </motion.video>
      <div className="absolute inset-0 bg-ink/75" />
      <div className="relative z-10 h-full container-x flex flex-col items-center justify-center text-center">
        <p className="font-display text-2xl sm:text-3xl lg:text-4xl text-white max-w-3xl leading-snug">
          « La route vous attend.
          <span className="gold-text"> Nous nous occupons du reste. »</span>
        </p>
        <span className="mt-6 h-px w-16 bg-gold/50" />
      </div>
    </section>
  );
}
